import types from 'redux/types';
import { checkTypeValue } from 'helpers';
import {
  baseAuth,
  fetchLogin,
  fetchLoginSuccess,
  fetchLoginFailed,
  fetchLogout,
  fetchLogoutSuccess,
} from 'redux/handleReducers';

const {
  REQUEST_API_LOGIN,
  REQUEST_API_LOGIN_FAILED,
  REQUEST_API_LOGIN_SUCCESS,
  REQUEST_API_LOGOUT,
  REQUEST_API_LOGOUT_SUCCESS,
} = types;

const initialState = {
  ...baseAuth(),
};

export default (state, actions) => {
  if (checkTypeValue(state, 'undefined')) {
    return initialState;
  }
  switch (actions.type) {
    case REQUEST_API_LOGIN:
      return fetchLogin(actions, state);

    case REQUEST_API_LOGIN_SUCCESS:
      return fetchLoginSuccess(actions, state);

    case REQUEST_API_LOGIN_FAILED:
      return fetchLoginFailed(actions, state);

    case REQUEST_API_LOGOUT:
      return fetchLogout(actions, state);

    case REQUEST_API_LOGOUT_SUCCESS:
      return fetchLogoutSuccess(actions, state);

    default:
      return state;
  }
};
